export const TEMPLATE_DIR = '/img/templates';
